import { useTranslation } from 'react-i18next'
import { BpButton } from '../../../shared/components/buttons/bp-button/BpButton'
import React from 'react'
import { useNavigate } from 'react-router-dom'

interface KeywordStubProps {
  project: string
}

export const MissingKeywordsStub = ({ project }: KeywordStubProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  // pt гасит -mt иконки: верх иконки совпадает с верхом заглушки, отступ сверху задаёт StubLayout
  return (
    <div className={'flex flex-wrap justify-center gap-[65px] px-[24px] pt-[11px] pb-[55px]'}>
      <div className={'-mt-[11px]'}>
        <svg
          className={'w-[144px]'}
          fill='none'
          viewBox='0 0 134 150'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            clipRule='evenodd'
            d='M93 0C106.807 3.22129e-07 118 11.1929 118 25V84.8828C114.219 83.6615 110.187 83 106 83C84.4605 83 67 100.46 67 122C67 132.987 71.545 142.912 78.8555 150H25C11.1929 150 4.02687e-07 138.807 0 125V25C1.61075e-06 11.1929 11.1929 3.22129e-07 25 0H93ZM58.6289 81.7617C53.9121 81.7617 50.1387 85.3105 50.1387 89.8027C50.1387 94.3398 53.9121 97.8887 58.6289 97.8887C63.3006 97.8885 67.1191 94.3397 67.1191 89.8027C67.1191 85.3107 63.3006 81.7619 58.6289 81.7617ZM60.3809 31C50.1837 31 42.6817 34.8634 39.6719 40.5234C38.7285 42.2305 38.2793 43.9824 38.2793 45.9141C38.2344 49.957 40.9297 52.5625 45.1523 52.5625C48.2967 52.5624 50.8575 51.0799 52.1602 48.1602C53.5527 44.881 55.9786 43.2188 59.5723 43.2188C63.615 43.2189 66.5352 45.7794 66.5352 49.418C66.5352 53.2812 64.9626 55.213 58.8535 58.8066C53.957 61.5918 51.3066 64.8711 51.3066 69.7676V70.0371C51.3066 74.3047 54.0918 77.2246 58.4043 77.2246C61.863 77.2245 63.9747 75.5624 65.0078 72.418C65.9062 69.1837 67.0743 67.5664 73.2285 64.0176C79.8318 60.1993 82.9316 55.6171 82.9316 49.0137C82.9316 38.0978 73.9919 31.0001 60.3809 31Z'
            fill='#00326D'
            fillRule='evenodd'
          />
          <path
            d='M106 94C110.295 94 114.363 94.9675 118 96.6953V97.7461C114.157 95.5232 109.737 94.1874 105.02 94.0186C105.345 94.0074 105.672 94 106 94Z'
            fill='#00326D'
          />
          <path
            clipRule='evenodd'
            d='M106 150C121.464 150 134 137.464 134 122C134 106.536 121.464 94 106 94C90.5356 94 78 106.536 78 122C78 137.464 90.5356 150 106 150ZM101.8 135.975C101.8 133.547 103.645 131.8 105.975 131.8C108.355 131.8 110.2 133.547 110.2 135.975C110.2 138.402 108.355 140.2 105.975 140.2C103.645 140.2 101.8 138.402 101.8 135.975ZM103.682 105.2C103.493 105.2 103.306 105.239 103.132 105.313C102.958 105.387 102.802 105.496 102.671 105.633C102.541 105.769 102.439 105.931 102.373 106.108C102.306 106.284 102.276 106.473 102.284 106.662L103.141 126.262C103.157 126.622 103.312 126.963 103.572 127.212C103.833 127.461 104.18 127.6 104.541 127.6H107.462C107.822 127.6 108.17 127.461 108.43 127.212C108.691 126.963 108.846 126.622 108.862 126.262L109.716 106.662C109.724 106.473 109.694 106.284 109.627 106.107C109.561 105.93 109.459 105.768 109.328 105.632C109.197 105.495 109.04 105.386 108.866 105.312C108.692 105.238 108.505 105.2 108.316 105.2H103.682Z'
            fill='#FF4980'
            fillRule='evenodd'
          />
        </svg>
      </div>
      <div className={'max-w-[485px] select-none'}>
        <h2 className={'hidden pb-[16px] text-[36px] leading-[48px] md:block'}>
          {t('components.keywordStub.missingKeywords')}
        </h2>
        <p className={'pb-[16px] text-[15px]'}>{t('components.keywordStub.addKeywordsFirst')}</p>
        <div className={'flex gap-[8px]'}>
          <BpButton
            className={'uppercase'}
            size={'md'}
            onClick={() => {
              navigate(`/projects/${project}/keywords`)
            }}
          >
            {t('buttons.addKeywords')}
          </BpButton>
        </div>
      </div>
    </div>
  )
}
